import { render } from "./CreateModal.vue?vue&type=template&id=d2326a56"
import script from "./CreateModal.vue?vue&type=script&lang=js"
export * from "./CreateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__